import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getEntriesNeedingRole,
  adminUpdateEntryRole,
  bulkSetRole,
  type AdminUpdateEntryRoleInput,
  type BulkSetRoleInput,
} from '../services/api/adminEntries';
import { invalidateMany } from './queryUtils';

export function useEntriesNeedingRole(params: {
  projectIds?: number[];
  userIds?: number[];
  fromMonth?: string;
  toMonth?: string;
  page?: number;
  pageSize?: number;
}) {
  return useQuery({
    queryKey: [
      'adminEntriesNeedingRole',
      params.projectIds ?? null,
      params.userIds ?? null,
      params.fromMonth ?? null,
      params.toMonth ?? null,
      params.page ?? 0,
      params.pageSize ?? 50,
    ],
    queryFn: () => getEntriesNeedingRole(params),
  });
}

export function useAdminUpdateEntryRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: AdminUpdateEntryRoleInput }) =>
      adminUpdateEntryRole(id, input),
    onSettled: () => {
      invalidateMany(queryClient, [['adminEntriesNeedingRole'], ['adminTimesheets']]);
    },
  });
}

export function useBulkSetRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: BulkSetRoleInput) => bulkSetRole(input),
    onSettled: () => {
      invalidateMany(queryClient, [['adminEntriesNeedingRole'], ['adminTimesheets']]);
    },
  });
}
